import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { Mail } from "lucide-react";
import brand from "@/config/brand";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-surface-50 text-ink-900">
      <Header />
      <main data-testid="contact-page">
        <section className="border-b border-surface-200 bg-white">
          <div className="mx-auto max-w-3xl px-6 pt-10 pb-8 lg:px-8 lg:pt-14 lg:pb-10">
            <p className="text-xs font-medium uppercase tracking-widest text-intel-800">Contact</p>
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-ink-900 sm:text-4xl">
              تواصل معنا
            </h1>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-ink-500">
              نُرحِّب باقتراحاتك، ملاحظاتك على الفرص، أو طلبات الشراكة والتغطية الإعلامية.
              نُجيب على كل رسالة خلال يومَي عمل.
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-3xl px-6 py-10 lg:px-8 lg:py-14">
          <a
            href={`mailto:${brand.contact.email}?subject=${encodeURIComponent("استفسار من موقع فرصالوجيا")}`}
            data-testid="contact-mailto"
            className="flex items-center justify-between gap-4 rounded-xl border border-surface-200 bg-white p-5 transition-colors hover:border-intel-300 hover:bg-surface-50"
          >
            <span className="flex items-center gap-3.5">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-intel-800 text-white">
                <Mail className="h-4 w-4" strokeWidth={1.75} />
              </span>
              <span className="flex flex-col">
                <span className="text-sm font-semibold text-ink-900">البريد الإلكتروني</span>
                <span dir="ltr" className="font-mono text-[13px] text-ink-500">
                  {brand.contact.email}
                </span>
              </span>
            </span>
            <span className="text-xs font-medium text-intel-800">إرسال ↩</span>
          </a>

          <p className="mt-6 text-xs leading-relaxed text-ink-500">
            للاستفسارات المتعلِّقة بالخصوصية والبيانات، راجع{" "}
            <a href="/privacy" className="font-medium text-intel-800 underline">
              سياسة الخصوصية
            </a>
            . للاستفسارات القانونية، راجع{" "}
            <a href="/terms" className="font-medium text-intel-800 underline">
              شروط الاستخدام
            </a>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
